import $ from 'jquery';
import 'slick-carousel';

export default () => {
  let $slick = $('.featured-news-archive__articles');

  if ($('.featured-news-archive__articles .featured-news-archive__articles__wrapper').length > 1) {
    $slick.not('.slick-initialized').slick({
      slidesToShow: 3,
      arrows: false,
      // centerMode: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
            arrows: false,
            // autoplay: true,
            // autoplaySpeed: 3000,
            // prevArrow: $previous,
            // nextArrow: $next,
            dots: false,
            adaptiveHeight: true,
            // asNavFor: $image,
            slidesToShow: 1,
            slidesToScroll: 1,
            // adaptiveHeight: true,
          },
        },
      ],
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/layouts/news-slider.js